<p-messages [(value)]="messages" key="dragdrop"></p-messages>
<div
  #dropArea
  class="drop-wrapper"
  [class.highlight-search-files]="highlightSearchFiles"
  [class.highlight-interpreter-files]="highlightInterpreterFiles"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <ng-content></ng-content>
  <div class="search-files">
    <p-button styleclass="upload-button" severity="secondary" icon="pi pi-upload" [rounded]="true"></p-button>
    <p class="text">
      Drop search files
    </p>
  </div>
  <div class="interpreter-files">
    <p-button styleclass="upload-button" severity="secondary" icon="pi pi-upload" [rounded]="true"></p-button>
    <p class="text">
      Drop interpreter files
    </p>
  </div>
</div>